var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.8139 0.130969C2.98852 -0.0436562 3.27164 -0.0436562 3.44627 0.130969L6.12919 2.8139C6.30382 2.98852 6.30382 3.27164 6.12919 3.44627C5.95457 3.62089 5.67145 3.62089 5.49682 3.44627L3.13008 1.07953L0.76334 3.44627C0.588716 3.62089 0.305593 3.62089 0.130969 3.44627C-0.0436562 3.27164 -0.0436562 2.98852 0.130969 2.8139L2.8139 0.130969Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.43f534a28d4a855328bd2dd09c0d0a0d.svg";
export { ForwardRef as ReactComponent };